const LISTING_CHANNEL_TYPES = new Set(['listing', 'listingVariant']);

/**
 * Resolves which asset id to load for a product grid card thumbnail.
 * Channel cards use published-view cover only (coverAssetId from search).
 * Master layers may still fall back to legacy assetId on the document.
 */
export default function getProductGridThumbnailAssetId(product) {
  if (!product) return null;

  if (LISTING_CHANNEL_TYPES.has(product.type)) {
    return product.coverAssetId || null;
  }

  return product.coverAssetId || product.assetId || null;
}
